export const MAP_CONFIG = {
    DEFAULT_PROVIDER: 'OpenStreetMapOrg',
    BASEMAPS: [
        {
            name: 'OpenStreetMapOrg',
            maxZoom: 19,
            layer: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            subdomains: 'abc',
            attribution: 'OpenStreetMap contributors',
        },
    ],
    CENTER: [-14.235, -51.9253],
    ZOOM_LEVEL: 4,
    ZOOM_LEVEL_RELEVE: 15,
    NEW_OBS_POINTER: 'assets/pointer-blue2.png',
    OBS_POINTER: 'assets/pointer-green.png',
};
